<template>
  <footer class="siimple-footer">
    <a href="https://www.sharecoto.co.jp/">sharecoto CO., LTD.</a> @{{year}}
  </footer>
</template>

<script>
export default {
  bane: 'page-footer',
  computed: {
    year () {
      return (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  text-align: center;
}
</style>
